import React, { Component } from 'react'
import { getInformationWithData, getInformationWithDataGlobalSales } from '../services/CABE.js'
import LoadingWindow from '../components/LoadingWindow';
import { getValueCookie } from '../services/cookieService.js';
import { BsSearch, BsArrowRepeat } from "react-icons/bs";
import { intervalTimeInDays } from '../functions/generalFunctions.js';
import { ActualDate, DateFormatMAS90 } from '../functions/dateFormat.js';
import ModalOrders from './ModalComponent.js';
import "../css/table-responsive.css"

export default class extends Component {

  constructor(props) {
    super(props);
    this.ModalLoading = React.createRef();

    this.state = {
      customerList: [],
      customerListShow: [],
      customerShow: [],
      showModal: false,
      currentPage: 0,
      ProductsPerPage: 60,
      TotalPages: 0
    }
  }

  componentDidMount() {
    // Get customers and save offline 
    if (this.props.isOnline) {
      this.setOfflineCustomers();
    }
  }

  // Normalization of customers
  normalizeCustomerKeys(customer) {
    const homologousKeys = {
      customerNo: 'CustomerNo',
      name: 'CustomerName',
      addressLine1: 'AddressLine1',
      addressLine2: 'AddressLine2',
      city: 'City',
      zipCode: 'ZipCode',
      telephoneNo: 'TelephoneNo',
      phone1: 'TelephoneNo',
      phone2: 'TelephoneNo',
      priceLevel: 'PriceLevel',
    };

    const normalized = {};

    // Recorremos todas las claves originales
    for (const key in customer) {
      let value = customer[key];
      // Si es el string 'null', lo convertimos en ''
      if (value === 'null') {
        value = '';
      }
      normalized[key] = value;
    }

    // Agregamos las claves legacy si no existen aún
    for (const [keyMin, keyLegacy] of Object.entries(homologousKeys)) {
      if (normalized[keyMin] !== undefined && normalized[keyLegacy] === undefined) {
        normalized[keyLegacy] = normalized[keyMin];
      }
    }

    return normalized;
  }


  // Get customers and save in local storage
  async setOfflineCustomers() {
    // Show sync message
    this.props.Padre.setState({syncCustomersStatus: 'started'});

    const salesPerson = getValueCookie('TypeUser') === '8' ? '0000' : getValueCookie('SalesPerson');
    const data = {
      SalespersonNo: salesPerson,
      idCompany: getValueCookie('SubCompanyId') ? Number(getValueCookie('SubCompanyId')) : Number(getValueCookie('CompanyId')),
      search: ""
    }
    // Get customers
    const response = await getInformationWithData('/customer/getListV3', data);

    if (response.status.code === 1 && response.data.length > 0) {
      // Save offline
      localStorage.setItem("offline_customers", JSON.stringify(response.data));
      // Save last syncronization
      localStorage.setItem("offline_customers_last_fetch", Date.now().toString());
      // Normalizar claves
      let customers = response.data ? response.data : [];
      customers = customers.map(this.normalizeCustomerKeys);
      // Save state
      this.setState({ customerList: customers, customerListShow: response.data });
      // Update sync message
      this.props.Padre.setState({syncCustomersStatus: 'done'});
    } 
  }

  // Fetches the customer list either from the backend or from localStorage depending on connection status and last fetch time
  async getCustomers(refresh) {
    // Open modal before loading customers
    await this.handleModalOpen();

    // Get salesperson ID from cookies; default to '0000' if TypeUser === '8'
    const salesPerson = getValueCookie('TypeUser') === '8' ? '0000' : getValueCookie('SalesPerson');
    const data = {
      SalespersonNo: salesPerson,
      idCompany: getValueCookie('SubCompanyId')
        ? Number(getValueCookie('SubCompanyId'))
        : Number(getValueCookie('CompanyId')),
    };

    // Get reference to the search input for focus control
    const searcher = document.getElementById('customer_busqueda_' + this.props.nombrePadre);

    // Determine whether to load data from localStorage
    const isOffline = !this.props.isOnline;
    const lastFetch = parseInt(localStorage.getItem("offline_customers_last_fetch") || "0", 10);
    const now = Date.now();
    const tenMinutes = 10 * 60 * 1000;

    // Use local data if offline or if last fetch was within 10 minutes and not forced refresh
    const useLocalData = (
      isOffline ||
      (!refresh && (now - lastFetch) < tenMinutes)
    );

    if (useLocalData) {
      // Load customers from localStorage
      const localData = localStorage.getItem("offline_customers");
      let customers = localData ? JSON.parse(localData) : [];
      // Ordenar por nombre (alfabéticamente, insensible a mayúsculas)
      customers = customers.sort(function (a, b) {
        var nameA = (a.name ? a.name.toUpperCase() : '');
        var nameB = (b.name ? b.name.toUpperCase() : '');
        return nameA.localeCompare(nameB);
      });
      // Normalizar claves
      customers = customers.map(this.normalizeCustomerKeys);
      // Update state
      this.setState({ customerList: customers, customerListShow: customers });
    } else {
      // Fetch fresh data from the backend and update state and localStorage
      this.ModalLoading.current.showState(true);
      this.setState({ customerList: [], customerListShow: [] });

      const respuesta = await getInformationWithData('/customer/getListV3', data);
      if (respuesta.status.code === 1) {
        // Normalizar claves
        let customers = respuesta.data ? respuesta.data : [];
        customers = customers.map(this.normalizeCustomerKeys);
        // Update state
        this.setState({ customerList: customers, customerListShow: respuesta.data });

        // Save to localStorage for offline use
        localStorage.setItem("offline_customers", JSON.stringify(respuesta.data));
        localStorage.setItem("offline_customers_last_fetch", now.toString());
      }

      this.ModalLoading.current.showState(false);
    }

    // Reset pagination and focus the search input
    this.setState({ customerListShow: this.state.customerList });
    await this.ResetPagination();
    searcher.value = '';
    setTimeout(() => { searcher.focus(); }, 300);
  }

  async getCustomer(CustomerNo) {
    const Father = this.props.Padre
    if (this.props.nombrePadre === 'Accounts') {
      await Father.clearAll()
      if (Father.state.select.label === 'FREIGHT' || Father.state.select.label === 'CREDITCARD FEE' || getValueCookie('CompanyId') === '6') {
        await Father.getNewCorrelativeInvoiceNumber()
      }
    }
    if (this.props.nombrePadre !== 'Customer' && this.props.nombrePadre !== 'Promotions') {

      CustomerNo.SalespersonNo = getValueCookie('SalesPerson')

      const temporal = Father.state[this.props.nombrePadre]
      temporal.Warehouse = CustomerNo.PriceLevel === '4' ? '003' : CustomerNo.PriceLevel === '5' ? '004' : '000'
      temporal[this.props.headerName] = CustomerNo

      if (this.props.nombrePadre === 'Invoice') {
        temporal.Warehouse = CustomerNo.PriceLevel === '4' ? '003' : temporal.Warehouse = CustomerNo.PriceLevel === '5' ? '004' : '000'
      }


      Father.setState({ [this.props.nombrePadre]: temporal })

      if (this.props.nombrePadre === 'SalesOrder' || this.props.nombrePadre === 'Invoice') {
        const data = {
          // CustomerNo: CustomerNo.CustomerNo,
          // username: getValueCookie('userName'),
          // company: getValueCookie('Company'),
          // idCompany: Number(getValueCookie('CompanyId'))
          SalespersonNo: getValueCookie('SalesPerson')
        }
        this.ModalLoading.current.showState(true);

        // Validate if is online
        if (this.props.isOnline) {
          const balance = await getInformationWithData('/customer/getBalanceV2', data)
          if (balance.status.code === 1) {
            balance.data.forEach(element => {
              element.PaymentDelayDays = intervalTimeInDays(DateFormatMAS90(element.InvoiceDueDate), ActualDate())
              element.InvoiceDate = DateFormatMAS90(element.InvoiceDate)
              element.InvoiceDueDate = DateFormatMAS90(element.InvoiceDueDate)
              element.CustomerName = CustomerNo.CustomerName
            });

            const temporalBalance = Father.state.Balance
            temporalBalance.HeaderBalance = balance.data
            temporalBalance.Detail = []
            temporalBalance.TermsCode = CustomerNo.TermsCodeDesc
            Father.setState({ Balance: temporalBalance })
            Father.getTotalBalance()
          }
          if (this.props.nombrePadre === 'SalesOrder') {
            Father.handleModalOpen("showModal1")
          } else if (this.props.nombrePadre === 'Invoice') {
            if (Father.state.Invoice.InvoiceType === 'CM') {
              Father.partialClear()
            }
            Father.handleModalOpen("showModal2")
          }
        }

        this.ModalLoading.current.showState(false);
      }
    } else if (this.props.nombrePadre === 'Promotions') {
      CustomerNo.SalespersonNo = getValueCookie('SalesPerson')
      let temporal = Father.state.Customer
      temporal = CustomerNo
      await Father.setState({ Customer: temporal })
      await Father.getCustomerPromotions()
    } else {
      const resultUser = await getInformationWithDataGlobalSales('/user/hasUser', { CustomerNo: CustomerNo.CustomerNo })

      CustomerNo.OrderType = 'customerManager'
      CustomerNo.New = 0
      CustomerNo.Route = CustomerNo.UDF_RUTA
      CustomerNo.Country = CustomerNo.CountryCode
      CustomerNo.Taxable = CustomerNo.TaxSchedule
      CustomerNo.Customer = CustomerNo.CountryCode
      CustomerNo.Fax = CustomerNo.FaxNo
      let temporal2 = Father.state[this.props.nombrePadre]
      temporal2 = CustomerNo
      await Father.setState({ [this.props.nombrePadre]: temporal2, PlatformCheck: resultUser.Active })
      await Father.setValues()
    }

    await this.handleModalClose()
  }

  contiene(parametro, busqueda) {
    if (parametro && busqueda) {
      return parametro.toString().toLowerCase().includes(busqueda.toLocaleLowerCase())
    }

  }

  buscarCustomer = e => {
    let busqueda = e.target.value;

    if (busqueda) {
      let customers = this.state.customerList.filter((customer_) => {
        if (((
          this.contiene(customer_.CustomerNo, busqueda) ||
          this.contiene(customer_.CustomerName, busqueda)
        ))
        ) {
          return customer_
        } else {
          return null
        }
      });
      this.setState({ customerListShow: customers });
    } else {
      let temporal = this.state.customerList
      this.setState({ customerListShow: temporal });
    }
    this.ResetPagination()
  }

  handleModalOpen = async () => {
    this.setState({ showModal: true });
  }

  handleModalClose = () => {
    this.setState({ showModal: false });
  }


  async ResetPagination() {
    let totalPages = Math.round(this.state.customerListShow.length / this.state.ProductsPerPage)
    let seeProds = this.state.customerListShow.slice(0, 0 + this.state.ProductsPerPage)
    await this.setState({
      customerShow: seeProds,
      currentPage: 0,
      ProductsPerPage: 30,
      TotalPages: totalPages
    })

  }

  async nextPage() {
    if ((this.state.currentPage + this.state.ProductsPerPage) <= this.state.customerListShow.length) {
      await this.setState({ currentPage: this.state.currentPage + this.state.ProductsPerPage })
    }
    this.updateSeeProducts()
    this.backToTop()
  }

  async prevPage() {
    if (this.state.currentPage > 0) {
      await this.setState({ currentPage: this.state.currentPage - this.state.ProductsPerPage })
    }
    this.updateSeeProducts()
    this.backToTop()
  }

  async updateSeeProducts() {
    let seeProds = this.state.customerListShow.slice(this.state.currentPage, this.state.currentPage + this.state.ProductsPerPage)
    await this.setState({
      customerShow: seeProds,
    })

  }
  backToTop() {

    const buscador = document.getElementById('customer_busqueda_' + this.props.nombrePadre);
    setTimeout(() => { buscador.focus(); }, 300);
  }

  getAddress(Customer) {
    let address = '';
    if (Customer.AddressLine1 && Customer.AddressLine1 !== 'null') {
      address = Customer.AddressLine1;
    } else if (Customer.addressLine1 && Customer.addressLine1 !== 'null') {
      const ad2 = Customer.addressLine2 && Customer.addressLine2 !== 'null' ? Customer.addressLine2 : '';
      address = `${Customer.addressLine1} ${ad2}`;
    }

    return address;
  }

  render() {
    return (
      <>
        
        <div className='col-sm-12 col-md-4'>
          <button type="button" disabled={this.props.disabled} className="btn blueButton btn-lg w-100 shadow" onClick={() => this.getCustomers(false)}> <BsSearch /> Customer List</button>
        </div>
        

        {/* Loading modal */}
        <LoadingWindow ref={this.ModalLoading} />

        {/* Customers list modal */}
        <ModalOrders title={'Customer List'} show={this.state.showModal} close={() => this.handleModalClose()}>
          <div className='row'>          
            <div className='row pt-1 pb-2'>
              <div className='row d-flex justify-content-center pb-4'>
                <div className='col-md-10 InputText'>
                  <div className="card shadow">
                    <div className="card-body d-flex justify-content-center">
                      <div className="input-group input-group-lg flex-nowrap">
                        <input className='form-control w-75 display-inline' placeholder='Search by CustomerNo or name' id={'customer_busqueda_' + this.props.nombrePadre} onChange={this.buscarCustomer} />
                        
                        {this.props.isOnline ? <button className='btn greenButton btn-lg' onClick={() => this.getCustomers(true)} style={{ height: '48px' }}><BsArrowRepeat /></button> : null}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>


            <div className='col-sm-12 tableFixHead'>
              <table className='table table-striped align-middle table-hover'>
                <thead>
                  <tr>
                    <th>Customer No</th>
                    <th>Customer Name</th>
                    <th>Address Line</th>
                    <th>City</th>
                    <th>Zip Code</th>
                    <th>Telephone No</th>
                    <th>Price Level</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    this.state.customerShow.map((Customer, i) => (
                      <tr key={i} className='' onClick={() => this.getCustomer(Customer)}>
                        <td className='text-center' style={{ cursor: 'pointer' }}>{Customer.CustomerNo || Customer.customerNo}</td>
                        <td className='text-start' style={{ cursor: 'pointer' }}>{Customer.CustomerName || Customer.name}</td>
                        <td className='text-start' style={{ cursor: 'pointer' }}>{this.getAddress(Customer)}</td>
                        <td className='text-center' style={{ cursor: 'pointer' }}>{Customer.City || Customer.city}</td>
                        <td className='text-center' style={{ cursor: 'pointer' }}>{Customer.ZipCode || Customer.zipCode}</td>
                        <td className='text-center' style={{ cursor: 'pointer' }}>{Customer.TelephoneNo || Customer.phone1 || Customer.phone2}</td>
                        <td className='text-center' style={{ cursor: 'pointer' }}>{Customer.PriceLevel || Customer.priceLevel}</td>
                      </tr>
                    ))
                  }
                </tbody>
                <tfoot>
                  <tr className='text-center'>
                    <td>
                      <div className="btn-group btn-group-lg" role="group" aria-label="pagination">
                        <button disabled={this.state.currentPage === 0} type="button" onClick={() => this.prevPage()} className="btn blueButton">Prev</button>
                      </div>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td className='text-center'>
                      <div className="btn-group btn-group-lg" role="group" aria-label="pagination">
                        <button disabled={(this.state.currentPage + this.state.ProductsPerPage) >= this.state.customerListShow.length} type="button" onClick={() => this.nextPage()} className="btn blueButton">Next</button>
                      </div>
                    </td>
                  </tr>
                </tfoot>
              </table>
            </div>
          </div>

        </ModalOrders>

      </>
    )
  }
}
